const defaultBase = {
  server: {
    api: "to-be-assigned",
    stock: "https://scan-dev.warriortrading.com",
    identity: "to-be-assigned",
    chatroom: "to-be-assigned",
    sim: "https://sim-dev.warriortrading.com",
  },
  debugModules: [
    {
      name: "agreement",
      description: "Quotemedia agreement",
    },
    {
      name: "announcements",
      description: "Announcements",
    },
    {
      name: "autoScroll",
      description: "Chatroom messages auto scroll",
    },
    {
      name: "bellSound",
      description: "BellSound",
    },
    {
      name: "chart",
      description: "Chart",
    },
    {
      name: "layout",
      description: "Layout",
    },
    {
      name: "localStorageLogsDebug",
      description: "LocalStorageLogsDebug",
    },
    {
      name: "messagesSource",
      description: "Chatroom messages",
    },
    {
      name: "news",
      description: "Collect sharedWorker news info logs",
    },
    {
      name: "performance",
      description: "Collect page CPU loads",
    },
    {
      name: "player",
      description: "Chatroom stream player",
    },
    {
      name: "privateChat",
      description: "PrivateChat",
    },
    {
      name: "profile",
      description: "Messages incidents",
    },
    {
      name: "rest",
      description: "Need in most watch cases",
    },
    {
      name: "screenCast",
      description: "ScreenCast",
    },
    {
      name: "session",
      description: "Session",
    },
    {
      name: "socketIO",
      description: "SocketIO",
    },
    {
      name: "stock",
      description: "Stock",
    },
    {
      name: "userList",
      description: "Current users list in rooms",
    },
    {
      name: "windowManagement",
      description: "Multiple windows management",
    },
    {
      name: "windowManagementHeartbeat",
      description: "windowManagementHeartbeat",
    },
    {
      name: "workerClientLog",
      description: "SocketIO client log",
    },
    {
      name: "sim",
      description: "Sim",
    },
    {
      name: "scanner",
      description: "Scanner",
    },
    {
      name: "remotes",
      description: "Remotes",
    },
    {
      name: "colorGroup",
      description: "ColorGroup",
    },
    {
      name: "utils",
      description: "Utils",
    },
    {
      name: "auth",
      description: "Auth",
    },
    {
      name: "hooks",
      description: "Hooks",
    },
    {
      name: "storage",
      description: "Storage",
    },
    {
      name: "store",
      description: "Store",
    },
    {
      name: "services",
      description: "Services",
    },
    {
      name: "worker",
      description: "GlobalStateWorker",
    },
    {
      name: "tradingView",
      description: "TradingView",
    },
    {
      name: "widgets",
      description: "Widgets",
    },
    {
      name: "sharedRemote",
      description: "SharedRemote",
    },
    {
      name: "tSettings",
      description: "TSettings",
    },
    {
      name: "tPositions",
      description: "TPositions",
    },
    {
      name: "tMonitors",
      description: "TMonitors",
    },
    {
      name: "tLevel2",
      description: "TLevel2",
    },
    {
      name: "tAccounts",
      description: "TAccounts",
    },
    {
      name: "sWatchList",
      description: "SWatchList",
    },
    {
      name: "sStockQuote",
      description: "SStockQuote",
    },
    {
      name: "sScanners",
      description: "SScanners",
    },
    {
      name: "sCharting",
      description: "SCharting",
    },
    {
      name: "sioWorker",
      description: "SioWorker",
    },
    {
      name: "riskWorker",
      description: "RiskWorker",
    },
  ],
  relationPageSize: 100,
  scannerServers: [
    {
      name: "scan-dev",
      value: "https://scan-dev.warriortrading.com",
      down: "",
      up: "",
    },
    {
      name: "scan-qa",
      value: "https://scan-qa.warriortrading.com",
      down: "https://scan-qa.warriortrading.com/ops-api/v1/down-hpas",
      up: "https://scan-qa.warriortrading.com/ops-api/v1/up-hpas",
    },
  ],
  chironQmApiHostOptions: [
    "https://app.quotemedia.com/",
    "https://quotes.quotemedia.com/",
  ],
};

const defaultConfig = { ...defaultBase };

export type ConfigType = typeof defaultConfig;
export default defaultConfig;
